export const brandName = process.env.REACT_APP_WEBSITE_BRAND
const basePath = process.env.REACT_APP_BASE_PATH

export function getKeyByValue(object, value) {
  return Object.keys(object).find(
    key =>
      object[key] === value ||
      object[key].toLowerCase() === value ||
      key === value
  )
}

export const pathMod = () => {
  return `/${basePath}`
}

export const brandNames = {
  vw6: 'VW',
  audi: 'Audi',
  skoda: 'Skoda',
  seat: 'Seat',
  vwcv: 'VWCV',
  vwfs: 'VW',
  cupra: 'Cupra',
}

export const bronsonConfig = {
  vw: {
    theme: 'vw6',
    version: '25.4.0',
  },
  vw6: {
    theme: 'vw6',
    version: '25.4.0',
  },
  audi: {
    theme: 'audi',
    version: '25.4.0',
  },
  skoda: {
    theme: 'skoda',
    version: '25.4.0',
  },
  seat: {
    theme: 'seat',
    version: '25.4.0',
  },
  vwcv: {
    theme: 'vw6',
    version: '25.4.0',
  },
  vwfs: {
    theme: 'bluelabel',
    version: '25.4.0',
  },
  dealer: {
    theme: 'bluelabel',
    version: '25.4.0',
  },
  cupra: {
    theme: 'cupra',
    version: '25.4.0',
  },
}

export const captchaSiteKey = {
  dev: {
    siteKey: 'FCMJBENC33L62PQ7',
  },
  int: {
    siteKey: 'FCMJBENC33DP4HIS',
  },
  cons: {
    siteKey: 'FCMJBENC30EK7K7H',
  },
  prod: {
    siteKey: 'FCMJBENC310PVR0M',
  },
}

export const resourcesBrand = getKeyByValue(brandNames, brandName) ?? 'vwfs'
export const getBrandName = () => {
  return brandNames[process.env.REACT_APP_WEBSITE_BRAND] ?? 'VW'
}

export const BRAND_NAME = process.env.REACT_APP_WEBSITE_BRAND
export const CONNECTION_TIMEOUT = 30000

export const ANALYTICS_DELAY = 2000

export const DATE_FORMAT = 'DD.MM.YYYY'
export const DATE_SEPARATOR = DATE_FORMAT.split('').find(item => {
  return !item.match(/^[a-zA-Z]*$/)
})
export const NUMBER_FORMAT = 'pl'
export const CURRENCY = 'EUR'
export const CURRENCY_SYMBOL = '€'
export const DECIMAL_SEPARATOR = ','
export const THOUSANDS_SEPARATOR = '.'

const getEnvironment = () => {
  return process.env.REACT_APP_ENVIRONMENT
    ? process.env.REACT_APP_ENVIRONMENT.toUpperCase()
    : 'error'
}

export const backendBrand = () => {
  switch (process.env.REACT_APP_WEBSITE_BRAND) {
    case 'vw6':
      return 'vw'
    default:
      return process.env.REACT_APP_WEBSITE_BRAND
  }
}

export const bronsonTheme =
  process.env.REACT_APP_WEBSITE_BRONSON_THEME || 'bluelabel'

export const getStylesCharly = carBrandName => {
  const brand = carBrandName.toLowerCase()

  switch (brand) {
    case 'seat':
      return import('@vwfs-uix/core/dist/themes/seat/styles/style.css')
    case 'audi':
      return import('@vwfs-uix/core/dist/themes/audi/styles/style.css')
    case 'skoda':
      return import('@vwfs-uix/core/dist/themes/skoda/styles/style.css')
    case 'vw6':
    case 'vw':
    case 'vwcv':
      return import('@vwfs-uix/core/dist/themes/vw6/styles/style.css')
    case 'cupra':
      return import('@vwfs-uix/core/dist/themes/cupra/styles/style.css')
    default:
      return import('@vwfs-uix/core/dist/themes/bluelabel/styles/style.css')
  }
}

const setAABrandName = () => (brandName === 'dealer' ? 'VWFS' : brandName)

export const ANALYTICS_DEFAULTS = {
  core: {
    /*
    Please put here the stage (DEV, INT, CONS, PROD) on which this site is
    */
    stagingEnvironment: getEnvironment(),

    // Constant value: 2.6
    dataLayerVersion: '2.6',
    pageInfo: {
      /*
        The values for pagename are defined in tracking specification
        document.
        */
      pageName: null,

      /*
        The device type the website is intended for.
        Type: Enum
        Mobile phone
        Tablet
        Desktop
        all
        */
      intendedCustomerDeviceType: 'all',

      /*
        Version or release of the site. Constant value of your choice
        which identifies best this current application version.
        */
      version: '14.0',

      /*
        Release date of this site as a constant value. Format YYYY-MM-DD
        */
      releaseDate: '2023-09-30',

      /*
        Current display language.
        Type: Enum
        ISO-639-2; lower case two letter code
        Hint: Visitor can change the language while his visit (e.g. in
        Switzerland).
        */
      language: 'pl',

      /*
        Type: Enum
        The country name of the market this site is serving
        (e.g. DE: W&I -> DE, UK: S&I -> UK).
        ISO-3166-1-alpha-2; upper case two letter code
        */
      market: 'PL',

      /*
        Type: Enum
        Name of responsible department (DU, local-DE, local-UK)
        */
      publisher: 'DU',
    },
    category: {
      /*
        Main category of this site.
        Type: Enum
        Banking
        Charge & fuel
        Customer portal
        Digital renewal
        Finance and lease
        Financing
        Fleet
        fob
        Insurance
        Leasing
        Local customer portal
        Local portal
        Local public site
        NBW
        Rental
        Service
        */
      primaryCategory: 'Service',

      /*
        Please further describe your journey/site *if necessary*. The
        product owner can choose a unique name.
        Examples:
        Champions Club
        Short term insurance
        */
      secondaryCategory: 'Service and inspection',

      /*
        Offered variants of the product that the customer can choose.
        E.g. basic / standard / premium variant of a contract
        */
      productVariants: [],

      /*
        If your journey splits in sub processes, standalone, checkout site,
        app, ...
        Type: Enum
        app
        checkoutSite
        standalone
        */
      siteType: 'Full journey',

      inventoryType: 'Non-Asset-based products',

      /*
        Classification of the result which should be achieved by the journey
        Type: Enum
        Lead
        Online contract
        */
      maturityLevel: 'Online contract',

      contractType: 'New',
    },
    attributes: {
      /*
        Type: Enum
        customer-facing-product-journey
        customer-facing-journey
        dealer-facing-product-journey
        dealer-facing-journey
        after-sales-journey
        */
      journeyType: 'customer-facing-product-journey',

      /*
        If your page contains expandables, which once expanded do not
        change the URL. Example: On page personal data, there are
        expandables for address, account details, ... The values are
        specified in the corresponding specification document.
        */
      viewChange: null,

      /*
        Refers to the branding of the site.

        Type: Enum
        Audi
        Bentley
        Cupra
        Ducati
        Lamborghini
        MAN
        Porsche
        Scania
        Seat
        Skoda
        VW
        VWCV
        VWFS
        */
      brand: setAABrandName() === 'DEALER' ? 'VWFS' : setAABrandName(),

      /*
        An ID for this transaction
        */
      transactionID: null,

      /*
      Indicates whether login is mandatory or optional
        Type: Enum
        Mandatory
        Optional
        */
      loginType: 'Optional',

      SandCtype: 'Active',
    },
  },
  /*
In case of any error situations (mainly standard errors like 401, 404, ...
and in context of forms) an error code (if available) and the error message
(if possible a shortened version) are placed here. If available the causing
URL (e.g. the wrong URL in case of 404, the referring URL in case 401, ...)
should be placed here, too.
*/
  error: {
    // Error code of application exceptions or caught errors
    errorCode: null,

    // Error message for caught errors with available message
    errorMessage: null,

    // Full URL which caused the error
    errorCausingURL: null,
  },

  /*
This structure is filled as soon as the user provides information
regarding any product.

Please note that this structure is an array structure. If the customer can
bundle his contract (i.e. get a leasing contract, a service and maintenance
package, and a tire package, this array should have three entries. Same is
e.g. in Customer portal uif customer has more than one product.
*/
  product: [
    {
      /*
    The name of the product from the given list. If you cannot find a
    suitable entry for the product sold in the journey, please reach out
    to the web analytics team. Please do not add any products to this list
    on your own.

    Type: Enum
    AutoCredit
    CarSharingProtection
    ChargeAndFuel
    ClassicCredit
    Credit
    CreditProtectionInsurance
    LeasingRateInsurance
    DigitalRenewal
    ExtendedWarranty
    FinanceLease
    GuaranteedAssetProtection
    MotorInsurance
    OperateLease
    RentalCarProtection
    ServiceInspection
    ServiceLimitedMaintenance
    TestDriveProtection
    ThirdPartyProtection
    UsedCarWarranty
    TirePackage
    */
      name: 'ServiceInspection',
      /*
    The main category of the current contract.
    Type: Enum
    Finance
    Insurance
    Leasing
    Service
    Other
    */
      category: 'Service',

      /*
        Further variants of the product, e.g. basic / standard / premium
        variant of a contract which the customer has chosen
        */
      productVariants: [],
      attributes: {
        /*
        Specifies the type of complete sales process

        Type: Enum
        Hybrid sales
        Online sales
        Partner sales
        */
        typeOfSale: null,

        /*
        Unit for payment frequency.
        Type: Enum
        single payment
        weekly payment
        biweekly payment
        monthly payment
        bimonthly payment
        quarterly payment
        biannual payment
        annual payment
        */
        paymentFrequency: null,

        /*
        The start date of contract in focus.
        Type: Date (YYYY-MM-DD)
        */
        startDateOfContract: null,

        /*
        Planned duration of contract; please use value -1 if indefinite
        Type: Integer
        */
        duration: null,

        /*
        Unit for planned duration of contract.
        Type: Enum
        WEEK
        TWO-WEEKS
        MONTH
        TWO-MONTHS
        QUARTER
        SIX-MONTHS
        YEAR
        */
        durationUnit: 'MONTH',

        /*
        Only if part of the contract
        Type: Integer
        */
        yearlyMileage: null,

        /*
        The unit of yearlyMileage, excessMileage or undrivenMileage.
        Should always be KILOMETERS in the european region.
        Type: Enum
        KILOMETERS,
        MILES
        */
        mileageUnit: 'KILOMETERS',

        /*
        The type of payment.

        Type: Enum

        Automatic Bank Transfer
        Credit Card
        Direct Deposit
        E-Wallet
        Mobile Payment
        */
        /* 2020-07-06 To get the type of payment requires greater effort.
           Therefore Stephane Petavy (PO ) decided to remove this variable.
        "paymentType": null,
        */

        /*
          The final amount customer has to pay to fulfill the contract.
          Type: Float
          The currency is the local currency.
          The value is stored without currency unit.
          */
        contractAmount: null,

        /*
        The date of actual registration. Only if part of the contract.
        Type: Date (YYYY-MM-DD)
        This is a particular important value. Do not skip it due to
        management request!
        */
        /*
        registrationDateOwner: null,
        */
        currency: 'PLN',
        /*
        E.g. monthly payment for insurance or leasing contract or an
        installment. Please provide exact (float) value
        Type: Float
        The currency is the local currency.
        The value is stored without currency unit.
        */
        recurringPayment: null,
      },
      // Aligned with BFF data model!
      vehicleModel: [
        {
          /*
        The manufacturer of the current vehicle.
        Type: Enum
        audi
        bentley
        cupra
        ducati
        man
        porsche
        scania
        seat
        skoda
        vw
        vwcv
        vwfs
        */
          manufacturer: getBrandName().toLowerCase(),

          /*
        The main name of the current car.

        Type: string, for example
        A3
        Kodiaq
        XC60
        Auris
        Golf
        */
          name: null,

          /*
        Long description of the vehicle model
        Type: String
        Example:
        Golf GTI Performance
        A3 Sportback 1.5 TFSI Black Edition
        */
          descriptionLong: null,

          /*
        The current mileage of the car
        Original value: 15388 km
        Data layer value: 15388
        Type: Integer
        */
          currentMileage: null,

          /*
        The unit of the current mileage of the car
        Type: Enum
        KILOMETERS,
        MILES
        */
          currentMileageUnit: 'KILOMETERS',

          /*
        The date when the vehicle has been registered first (In german
        "Tag der Erstzulassung").

        This value is of special importance to be tracked correctly as it
        serves as a measure for customer loyalty. Tracking this value
        correctly is of high importance for our management.
        Type: String
        Format: YYYY-MM-DD
        */
          initialRegistrationDate: null,

          /*
        The type of usage

        Enum:
        Private
        Business
        Both
        */
          typeOfUse: null,
        },
      ],
    },
  ],
  dealerData: {
    /*
    The 5-digit company id which uniquely identifies the car dealer within
    the VW ecosystem.
    Type: string
    */
    companyId: null,

    /*
    The company name of the car dealer.
    Type: string
    */
    companyName: null,

    /*
    The 3-digit region id allows to group car dealers in the VW ecosystem
    by regions. The region id should be sent with every transaction to
    correctly assign transactions to regional systems.
    Type: string
    */
    regionId: null,
    address: {
      // Dealers address
      street: null,
      // The postal code of dealer’s address.
      zipCode: null,
      // The city of the address.
      city: null,
      /* The region the dealer is located. In Germany this would be the
        federal state.
        */
      state: null,
    },
  },
  design: {
    /*
    For responsive design: Thresholds when design changes. The values are
    the Bronson breakpoints:
    xxl   (browser tab width >= 1920 px)
    xl    (browser tab width >= 1600 px)
    l     (browser tab width >= 1280 px)
    m     (browser tab width >=  960 px)
    s     (browser tab width >=  720 px)
    xs    (browser tab width >=  480 px)
    Type: string
    */
    browserResolutionBreakpoint: null,
  },
  customerData: {
    /*
    Indicates whether the user is currently logged in or not
    Type: Boolean
    */
    loginStatus: false,

    /*
    The user group the customer belongs to. Specified values are:
    - private
    - business (small)
    - business (corporate)
    - business
    (the latter applies if there is no differentiation according to
    company size)
    If there is no data available the value is
    - not available
    */
    loggedInUserGroup: null,

    /*
    SHA-256 hash of customer's email address.
    Type: String
    */
    eHash: '',

    /*
    SHA-256 hash of customer's phone number (E.164 format).
    Type: String
    */
    pHash: '',

    /*
    The year the customer was born.
    Type: Integer
    Format: YYYY
    */
    yearOfBirth: null,

    /*
    The gender of the customer
    Type: Enum
    MALE
    FEMALE
    */
    gender: null,
    address: {
      /*
      If the customer provides multiple addresses, we expect the zip
      code of latest address here.
      */
      zipCode: null,
    },
  },
  dataPrivacyStatement: {
    /*
    If the customer allows a contact via phone the value is "Phone".
    When distinguishing between contact partners please use the
    descriptive term as Suffix (enclosed in round brackets).
    Example:
    Phone
    Phone (VWFS)
    Phone (BP) // in case of Business partner
    Type: String
    */
    allowPhoneAds: null,

    /*
    If the customer allows a contact via Electronic channels the value is
     "Electronic". When distinguishing between contact partners please use
    the descriptive term as Suffix (enclosed in round brackets).
    Example:
    Electronic
    Electronic (VWFS)
    Electronic (BP) // in case of Business partner
    Type: String
    */
    allowElectronicAds: null,

    /*
    If the customer allows a contact via mail the value is "Mail".
    When distinguishing between contact partners please use the
    descriptive term as Suffix (enclosed in round brackets).
    Example:
    Mail
    Mail (VWFS)
    Mail (BP) // in case of Business partner
    Type: String
    */
    allowMailAds: null,
  },
  /*
Together with the PO or BA we map our standard events to your journey and
provide you a specification document with an annotated version of the
journey. Please fill use the values specified in this document.
*/
  event: [
    {
      eventInfo: {
        /*
        The type of event which occurred. This information describes the
        context in which the current event occurred. The values are
        specified in the corresponding specification document.
        */
        eventType: null,

        /*
        The event which occurred. The values are specified in the
        corresponding specification document.
        */
        eventAction: null,

        /*
        If a link or button triggers this event, please provide the target
        url of this link.
        */
        eventTargetURL: null,

        /*
        If additional information in context of an interaction element
        is needed. The values are specified in the corresponding
        specification document.
        */

        linkInformation: null,
      },
    },
  ],
}
